<section>
  <mds-grid [overrides]="overrides"
            [sizeColumnsToFit]="true"
            [themeClass]="'ag-theme-material'"
            [minHeight]="'400px'"
            [storageKey]="'score-compare-table'"
            (gridReady)="onGridReady($event)"
  ></mds-grid>
</section>





